import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";

import Logo from "../../Assets/Images/footer/logo.png";
import FacebookIcon from "../../Assets/Images/footer/facebookIcon.png";
import InstagramIcon from "../../Assets/Images/footer/instagramIcon.png";
import SignupSubmit from "../../Assets/Images/footer/signupSubmit.png";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { signupEmail: "Email address", signupMessage: "" };
    console.log("checkstateFrom:" + JSON.stringify(this.state));
  }
  render() {
    return (
      <div className="footer">
        <footer>
          <div className="logo">
            <img className="logoImg" src={Logo} alt="logo" />
          </div>
          {/*contact section*/}
          <div className="contactInfo">
            <ul>
              <li>Wisma Methodist,Lorong Hang Jebat,50150 Kuala Lumpur</li>
              <li>Tel: 603 2070 2501</li>
              <li>Email: mcrdmalaysia@gmail.com</li>
              <li>
                <a href="https://www.facebook.com/cacmcrd/?ref=page_internal">
                  <img src={FacebookIcon} />
                </a>
                <a href="https://www.instagram.com/mcrdmalaysia/?r=nametag">
                  <img src={InstagramIcon} />
                </a>
              </li>
            </ul>
          </div>
          {/*quick nav section*/}
          <div className="footNav">
            <ul>
              <li>
                <div onClick={() => this.props.updateScrollPos(0)}>
                  <Link to="/AboutUs">About us</Link>
                </div>
              </li>
              <li>
                <div onClick={() => this.props.updateScrollPos(0)}>
                  <Link to="/Ministries">Our ministries</Link>
                </div>
              </li>
              <li>
                <div onClick={() => this.props.updateScrollPos(0)}>
                  <Link to="/GetInvolved">Get involved</Link>
                </div>
              </li>
              <li>
                <div onClick={() => this.props.updateScrollPos(0)}>
                  <Link to="/">Contact us</Link>
                </div>
              </li>
              <li>
                <div onClick={() => this.props.updateScrollPos(0)}>
                  <Link to="/">Donate</Link>
                </div>
              </li>
            </ul>
          </div>
          {/*signup section*/}
          <div className="signup">
            <label>Singup for more updates from MCRD !</label>
            <div className="formInputLayer">
              <input type="text" value={this.state.signupEmail} onChange={(e) => this.updateEmail(e.target.value)} onFocus={() => this.signupFocus()} />
              <Button onClick={() => this.signupSubmit()}>
                <img className="signupSubmitBtn" src={SignupSubmit} alt="signupSubmit" />
              </Button>
            </div>
            <div className="formOutputLayer">{this.state.signupMessage}</div>
          </div>
        </footer>
      </div>
    );
  }
  updateEmail = (e) => {
    this.setState({ signupEmail: e });
  };
  signupFocus = () => {
    this.setState({ signupEmail: "" });
  };
  signupSubmit = () => {
    if (this.state.signupEmail !== "" && this.state.signupEmail.includes("@") && this.state.signupEmail.includes(".com")) {
      const date = new Date();
      const data = {
        email: this.state.signupEmail,
        date: date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear(),
      };
      axios.post("https://sheet.best/api/sheets/54d5183f-25e2-482d-a53a-a08fbdd2c018", data).then((response) => {
        console.log(response);
      });
      this.setState({ signupMessage: "signup success!" });
    } else {
      this.setState({ signupMessage: "wrong email address!" });
    }
  };
}
export default Footer;
